
	frappe.templates['kanban_card'] = `<div class="kanban-card-wrapper {{ disable_click }}" data-name="{{encodeURIComponent(name)}}">
	<div class="kanban-card content">
		<div class="kanban-card-body">
			<div class="kanban-title-area">
				<div class="kanban-card-header">
					{{ avatar_html }}
					<a href="{{ form_link }}" class="kanban-card-title-link">
						<div class="kanban-card-title ellipsis" title="{{title}}">
							{{ title }}
						</div>
					</a>
				</div>
				{% if(doc_content) { %}
				<div class="kanban-card-doc text-muted">
					{{ doc_content }}
				</div>
				{% } %}
			</div>
			<div class="kanban-card-meta">
			</div>
		</div>
	</div>
</div>
`;
